<template>
  <div>
    <v-toolbar flat :color="ui.bkgdColor">
      <v-toolbar-title :class="ui.textTitle">
        {{this.getUser.basic.title}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-spacer/>
      <v-chip :color="ui.bkgdColor" :text-color="dataSavePendingColor">
        <v-icon> cloud </v-icon>
      </v-chip>
      <v-chip :color="ui.bkgdColor" :text-color="dataUserAdminPendingColor"
      v-if="this.getDetail.basic.act === false">
        <v-icon> person </v-icon>
      </v-chip>
      <DataPrivacyCard :data="{btnSize: 'icon'}"
      v-if="this.getDetailBasic.rdp !== this.getDataPrivacy.char.rev"/>
      <TermsAndConditionsCard :data="{btnSize: 'icon'}"
      v-if="this.getDetailBasic.rtc !== this.getTermsAndConditions.char.rev"/>
    </v-toolbar>
    <v-tabs :color="ui.bkgdColor" :slider-color="ui.sliderColor" v-model="tab">
      <v-tab href="#tab-1">
        <v-tabs-slider/>
        <div :class="ui.textColorSecondary">
          Info
        </div>
      </v-tab>
      <v-tab href="#tab-2">
        <div :class="ui.textColorSecondary">
          Contact
        </div>
      </v-tab>
      <v-tab href="#tab-3">
        <div :class="ui.textColorSecondary">
          Role
        </div>
      </v-tab>
      <v-tab href="#tab-4">
        <div :class="ui.textColorSecondary">
          Skills
        </div>
      </v-tab>
      <v-tab href="#tab-5">
        <div :class="ui.textColorSecondary">
          Pref
        </div>
      </v-tab>
      <v-tab href="#tab-6">
        <div :class="ui.textColorSecondary">
          Support
        </div>
      </v-tab>
      <v-tab href="#tab-7">
        <div class="body wplblue0--text">
          Attach
        </div>
      </v-tab>
      <v-tab href="#tab-8">
        <div class="body wplblue0--text">
          Revs.
        </div>
      </v-tab>
      <!-- Basic / Info -->
      <v-tab-item :key="1" :value="'tab-1'">
        <UserDetailInfo v-if="true"/>
      </v-tab-item>
      <!-- Contact Info -->
      <v-tab-item :key="2" :value="'tab-2'">
        <UserDetailContact v-if="this.tab === 'tab-2'"/>
      </v-tab-item>
      <!-- Role and Job Title -->
      <v-tab-item :key="3" :value="'tab-3'">
        <v-container :class="ui.bkgdColor">
          <UserDetailRole v-if="this.tab === 'tab-3'"/>
        </v-container>
      </v-tab-item>
      <!-- Role and Job Title -->
      <v-tab-item :key="4" :value="'tab-4'">
        <v-container :class="ui.bkgdColor">
          <UserDetailSkills v-if="this.tab === 'tab-4'"/>
        </v-container>
      </v-tab-item>
      <!-- Preferences and Settings -->
      <v-tab-item :key="5" :value="'tab-5'">
        <v-container :class="ui.bkgdColor">
          <UserDetailPref v-if="this.tab === 'tab-5'"/>
        </v-container>
      </v-tab-item>
      <!-- Support Features -->
      <v-tab-item :key="6" :value="'tab-6'">
        <v-container :class="ui.bkgdColor">
          <UserDetailSupport v-if="this.tab === 'tab-6'"/>
        </v-container>
      </v-tab-item>
      <!-- <Attach/> -->
      <v-tab-item :key="7" :value="'tab-7'">
        <v-container :class="ui.bkgdColor">
          <Attachments v-if="this.tab === 'tab-7'"/>
        </v-container>
      </v-tab-item>
      <!-- <Revisions/> -->
      <v-tab-item :key="8" :value="'tab-8'">
        <v-container :class="ui.bkgdColor">
          <RevisionDash v-if="this.tab === 'tab-8'"/>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <DetailChange :data="{type: 'user'}"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserDetailInfo from "@/user/user/components/UserDetailInfo";
import UserDetailContact from "@/user/user/components/UserDetailContact";
import UserDetailPref from "@/user/user/components/UserDetailPref";
import UserDetailRole from "@/user/user/components/UserDetailRole";
import UserDetailSkills from "@/user/user/components/UserDetailSkills";
import UserDetailSupport from "@/user/user/components/UserDetailSupport";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import RevisionDash from "@/document/revisions/components/RevisionDash";
import DetailChange from "@/support/detail/components/DetailChange";
import Attachments from "@/document/attachments/components/Attachments";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import DataPrivacyCard from "@/admin/privacy/components/DataPrivacyCard";
import TermsAndConditionsCard from "@/admin/tc/components/TermsAndConditionsCard";

export default {
  components: {
    Attachments,
    DetailChange,
    UserDetailContact,
    UserDetailInfo,
    UserDetailPref,
    UserDetailRole,
    UserDetailSkills,
    UserDetailSupport,
    RevisionDash,
    DataPrivacyCard,
    TermsAndConditionsCard
  },
  mixins: [apptheme, storeFunctions],
  data() {
    return {
      valid: true,
      value: "",
      tab: "tab-1"
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getUser",
      "getDetail",
      "getDetailBasic",
      "getDataPrivacy",
      "getTermsAndConditions",
      "getDataSavePendingIndication"
    ]),
    ds() {
      return this.getDetail;
    },
    dataSavePendingColor() {
      // eslint-disable-next-line
      if (this.getDataSavePendingIndication === true) {
        return "wplorange0";
      } else {
        return this.ui.bkgdColor;
      }
    },
    dataUserAdminPendingColor() {
      // eslint-disable-next-line
      if (this.getUser.basic.act === false) {
        return "wplred0";
      } else {
        return this.ui.bkgdColor;
      }
    }
  }
};
</script>
